import axios from 'axios';
import config from '../config/api';

const API_URL = config.endpoints.hospitales;

// Obtener todos los hospitales
export const getAllHospitales = (page = null, pageSize = null) => {
    let url = `${API_URL}/`;
    const params = [];
    if (page) params.push(`page=${page}`);
    if (pageSize) params.push(`pageSize=${pageSize}`);
    if (params.length) url += `?${params.join('&')}`;
    return axios.get(url);
};

// Crear un nuevo hospital
export const createHospital = (data) => {
    const payload = {
        HOSPITAL_NOMBRE: data.nombre,
        HOSPITAL_DIRECCION: data.direccion,
        HOSPITAL_TIPOINSTITUCION: data.tipoInstitucion,
        HOSPITAL_PAIS: data.provincia || 'Ecuador', // Mapear provincia a país
        HOSPITAL_TELEFONO: data.telefono,
        HOSPITAL_CORREO: data.correoContacto
    };
    return axios.post(`${API_URL}/crear`, payload);
};

// Actualizar hospital existente
export const updateHospital = (id, data) => {
    const payload = {
        HOSPITAL_NOMBRE: data.nombre,
        HOSPITAL_DIRECCION: data.direccion,
        HOSPITAL_TIPOINSTITUCION: data.tipoInstitucion,
        HOSPITAL_PAIS: data.provincia || 'Ecuador', // Mapear provincia a país
        HOSPITAL_TELEFONO: data.telefono,
        HOSPITAL_CORREO: data.correoContacto
    };
    return axios.put(`${API_URL}/actualizar/${id}`, payload);
};

// Eliminar hospital
export const deleteHospital = (id) => {
    return axios.delete(`${API_URL}/eliminar/${id}`);
};

// Obtener hospital por ID
export const getHospitalById = (id) => {
    return axios.get(`${API_URL}/id/${id}`);
};

// Buscar hospital por nombre
export const getHospitalByName = (nombre) => {
    return axios.get(`${API_URL}/nombre/${nombre}`);
};

export default {
    getAllHospitales,
    createHospital,
    updateHospital,
    deleteHospital,
    getHospitalById,
    getHospitalByName
};